<div class="card p-3 my-2">
  <div class="row g-3 align-items-center">

    <div class="col-auto">
      <img
        [src]="data?.photoThumb  ? urlJoin(environment.storageUrl,data?.photoThumb) : 'assets/media/no-image.jpg'"
        alt="Building photo"
        class="rounded"
        height="180"
        style="object-fit: cover;"
        width="180"
      />
    </div>

    <div class="col d-flex ms-2 flex-column">
      <div class="d-flex justify-content-between align-items-start gap-4">
        <div>
          <h4 class="mb-1 fw-bold">{{ data.name }}</h4>
          <p class="text-muted mb-1">
            {{ data?.addressBook?.street }} {{ data?.addressBook?.houseNumber }}, {{ data?.addressBook?.postalCode }} {{ data?.addressBook?.city }}
          </p>
        </div>

        <span [type]="data.currentState" propertyStatusBadge></span>
      </div>

      <h6 class="mt-4 fw-bold">{{ 'APARTMENT.DESCRIPTION' | translate }}</h6>
      <p class="mb-2 text-muted">
        {{ data?.description||'-' }}
      </p>
      @if(showDetails) {
        <a *ngCan="'buildings.show'" [routerLink]="[Resources.PropertiesProfile | resourceById:data.id]"
           class="btn btn-primary btn-sm align-self-start">
          <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.37923 9.6564C9.38752 9.76663 9.35229 9.87571 9.28109 9.96026C9.20989 10.0448 9.10839 10.0981 8.99836 10.1087H4.54691C4.43955 10.0912 4.3419 10.0361 4.27144 9.95326C4.20097 9.8704 4.16228 9.76517 4.16228 9.6564C4.16228 9.54763 4.20097 9.4424 4.27144 9.35954C4.3419 9.27668 4.43955 9.22159 4.54691 9.20411H8.99241C9.10351 9.21323 9.2065 9.26588 9.27896 9.3506C9.35141 9.43531 9.38745 9.54523 9.37923 9.6564ZM4.67783 7.67467H6.55839C6.67731 7.67311 6.79083 7.62476 6.87437 7.54011C6.9579 7.45546 7.00474 7.34131 7.00473 7.22238C7.00477 7.10289 6.95813 6.9881 6.87475 6.9025C6.79137 6.8169 6.67785 6.76725 6.55839 6.76415H4.67188C4.61248 6.76492 4.55382 6.77739 4.49925 6.80084C4.44467 6.82429 4.39524 6.85826 4.3538 6.90082C4.31235 6.94337 4.27969 6.99367 4.25769 7.04884C4.23568 7.10402 4.22476 7.16299 4.22555 7.22238C4.22476 7.2815 4.23572 7.34018 4.2578 7.39502C4.27987 7.44986 4.31263 7.49977 4.35415 7.54184C4.39568 7.58392 4.44515 7.61733 4.49969 7.64014C4.55423 7.66294 4.61276 7.67468 4.67188 7.67467H4.67783ZM13.4022 6.06191C13.4056 6.03225 13.4056 6.0023 13.4022 5.97264C13.4217 5.89752 13.4215 5.81865 13.4017 5.74361C13.3819 5.66857 13.3432 5.59988 13.2891 5.54416L8.52822 0.705888C8.49076 0.669425 8.44619 0.641065 8.39729 0.622572H8.36159C8.32012 0.616939 8.27808 0.616939 8.23661 0.622572H4.37432C3.36976 0.631927 2.40917 1.03595 1.69992 1.74743C0.990668 2.45891 0.589655 3.42076 0.583449 4.42535V9.51952C0.577105 10.5324 0.972568 11.5064 1.68316 12.2281C2.39376 12.9499 3.36152 13.3605 4.37432 13.3699H9.62323C10.636 13.3605 11.6038 12.9499 12.3144 12.2281C13.025 11.5064 13.4204 10.5324 13.4141 9.51952L13.4022 6.06191ZM8.64129 2.12226L11.8787 5.41324H10.141C9.73899 5.40853 9.35516 5.24513 9.07313 4.95864C8.7911 4.67215 8.63374 4.28581 8.63534 3.8838L8.64129 2.12226ZM9.62918 12.4653H4.37432C3.9906 12.4622 3.61124 12.3836 3.25792 12.2338C2.90459 12.0841 2.58422 11.8662 2.3151 11.5927C2.04597 11.3191 1.83336 10.9953 1.68941 10.6396C1.54546 10.2838 1.47298 9.90325 1.47612 9.51952V4.42535C1.47298 4.04162 1.54546 3.66103 1.68941 3.30532C1.83336 2.9496 2.04597 2.62572 2.3151 2.35218C2.58422 2.07863 2.90459 1.86077 3.25792 1.71104C3.61124 1.56132 3.9906 1.48265 4.37432 1.47954H7.74267V3.85999C7.73944 4.49728 7.98752 5.11016 8.43311 5.56579C8.87871 6.02141 9.48592 6.28305 10.1231 6.29401H12.5036V9.49572C12.5099 9.87995 12.4403 10.2616 12.2989 10.619C12.1575 10.9763 11.947 11.3022 11.6794 11.578C11.4119 11.8539 11.0925 12.0742 10.7397 12.2265C10.3869 12.3787 10.0075 12.4599 9.62323 12.4653H9.62918Z"
              fill="white"/>
          </svg>

          {{ 'PROPERTY.SHOW_DETAILS' | translate }}
        </a>
      }
      <ng-content></ng-content>
    </div>

    <div class="col-auto responsive-box">
      <div class="row gx-3">
        <div class="col-lg-6">
          <card
            type="no-title"
            [title]="translateService.instant('PROPERTY.BUILDING_TYPE')"
            [value]="data?.buildingType?.translatedText"
            icon="ri-home-4-line"
            [isLoading]="!data"
          />
        </div>
        <div class="col-lg-6">
          <card
            type="no-title"
            [title]="translateService.instant('PROPERTY.CONSTRUCTION_YEAR')"
            [value]="(data?.constructionYear|date:'yyyy') ?? '-'"
            icon="ri-calendar-check-line"
            [isLoading]="!data"
          />
        </div>
      </div>

      <div class="row gx-3">
        <div class="col-lg-4">
          <card
            type="no-title"
            [title]="translateService.instant('PROPERTY.FLOORS')"
            [value]="data?.floors ?? 0"
            icon="ri-menu-5-fill"
            [isLoading]="!data"
          />
        </div>
        <div class="col-lg-4">
          <card
            type="no-title"
            [title]="translateService.instant('PROPERTY.AREA')"
            [value]="data?.totalArea ?? 0"
            icon="ri-ruler-line"
            valueType="m2"
            [isLoading]="!data"
          />
        </div>
        <div class="col-lg-4">
          <card
            type="no-title"
            [title]="translateService.instant('PROPERTY.RESIDENTIAL_UNITS')"
            [value]="data?.countResidentialUnits"
            icon="bi bi-door-open"
            [isLoading]="!data"
          />
        </div>
      </div>

      <div class="row gx-3">
        <div class="col-lg-6">
          <card
            type="no-title"
            [title]="translateService.instant('PROPERTY.COMMERCIAL_UNITS')"
            [value]="data?.countCommercialUnits || 0"
            icon="bi bi-shop"
            [isLoading]="!data"
          />
        </div>
        <div class="col-lg-6">
          <card
            type="no-title"
            [title]="translateService.instant('PROPERTY.OCCUPANCY')"
            [value]="data?.occupancyPercentage || 0"
            icon="bi bi-percent"
            valueType="percent"
            [isLoading]="!data"
          />
        </div>
      </div>
    </div>
  </div>
</div>
